
export default {
  namespaced: true,
  state: {
    visible: false,
    tipConfig: null,
  },
  getters: {
    visible: (state) => state.visible,
    tipOptions: (state, getters, rootState) => {
      const tipConfig = rootState.location.config.tip;

      const { subtotal, taxes } = rootState.order;

      const orderTaxes = taxes ? taxes : 0;

      const baseAmount = tipConfig.taxInclusive
        ? subtotal + orderTaxes
        : subtotal;

      const tipCalcs = tipConfig.options.map((percent) => {
        const amount = baseAmount * (percent / 100);
        return { percent, amount };
      });
      return tipCalcs;
    },
    tipConfig: (state) => state.tipConfig,
    selectedTip: (state) => state.selectedTip,
  },
  mutations: {
    LOAD_CONFIG(state, config) {
      state.tipConfig = config.tip;
    },
    RESET(state) {
      state.tipConfig = null;
    },
    SET_TIP_VISIBILITY(state, visible) {
      state.visible = visible;
    },
  },
  actions: {
    init({ commit, rootState }) {
      commit('LOAD_CONFIG', rootState.location.config);
    },
    show({ commit }) {
      commit("RESET");
      commit("SET_TIP_VISIBILITY", true);
    },
    hide({ commit }) {

      commit("SET_TIP_VISIBILITY", false);
    },
  },
};
